import { Routes } from '@angular/router';
import { authGuard } from '../guards/auth.guard';

export const userDocumentationRoutes: Routes = [
  ...(
    [
      ['avv', 'AVV'],
      ['leistungen', 'Leistungen'],
      ['erloeskonten', 'Erlöskonten'],
      ['notifizierungen', 'Notifizierungen'],
      ['mitarbeiter', 'Mitarbeiter'],
      ['kontakte', 'Kontakte'],
    ] as const
  ).map(([chapter, title]) => ({
    path: `handbuch/stammdaten/${chapter}`,
    title: `Benutzerhandbuch · Stammdaten · ${title}`,
    loadComponent: () => import('./user-documentation').then(m => m.UserDocumentation),
    canActivate: [authGuard],
    data: { chapter },
  })),
  ...(
    [
      ['auftragsuebersicht', 'Übersicht'],
      ['auftragsdetails', 'Auftragsdetails'],
      ['auftragsformular', 'Auftragsformular'],
    ] as const
  ).map(([chapter, title]) => ({
    path: `handbuch/auftraege/${chapter}`,
    title: `Benutzerhandbuch · Aufträge · ${title}`,
    loadComponent: () => import('./user-documentation').then(m => m.UserDocumentation),
    canActivate: [authGuard],
    data: { chapter },
  })),
  {
    path: 'handbuch/administration/benutzerverwaltung',
    title: 'Benutzerhandbuch · Administration · Benutzerverwaltung',
    loadComponent: () => import('./user-documentation').then(m => m.UserDocumentation),
    canActivate: [authGuard],
    data: { chapter: 'benutzerverwaltung' },
  },
  {
    path: 'handbuch',
    pathMatch: 'full',
    redirectTo: 'handbuch/stammdaten/einheiten',
  },
  {
    path: 'handbuch/stammdaten/einheiten',
    title: 'Benutzerhandbuch · Stammdaten · Einheiten',
    loadComponent: () => import('./user-documentation').then(m => m.UserDocumentation),
    canActivate: [authGuard],
    data: { chapter: 'einheiten' },
  },
  {
    path: 'handbuch/stammdaten/terminarten',
    title: 'Benutzerhandbuch · Stammdaten · Terminarten',
    loadComponent: () => import('./user-documentation').then(m => m.UserDocumentation),
    canActivate: [authGuard],
    data: { chapter: 'terminarten' },
  },
];
